import React from 'react';

const ContentSection = ({
  title,
  subtitle,
  paragraphs = [],
  image,
  imageAlt = '',
  imageLeft = false,
  isQuote = false,
  bgClass = '',
  whiteText = false,
  subtitleBlue = false,
  children,
}) => {
  const textColor = whiteText ? 'text-white' : 'text-[#1a1a2e]';
  const paraColor = whiteText ? 'text-white/80' : 'text-[#4a4a6a]';

  return (
    <section className={`py-[60px] ${bgClass}`}>
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <div className={`flex flex-col ${imageLeft ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-8 lg:gap-12`}>
          {/* Text Column */}
          <div className="w-full lg:w-7/12">
            <h2 className={`text-[28px] md:text-[34px] font-bold mb-4 leading-tight ${textColor}`}>
              {title}
            </h2>
            {subtitle && (
              <h3 className={`text-lg md:text-xl font-semibold mb-4 ${
                subtitleBlue ? 'text-[#0E47B0]' : whiteText ? 'text-white/90' : 'text-[#1a1a2e]/80'
              }`}>
                {subtitle}
              </h3>
            )}
            {paragraphs.map((p, i) => (
              <p key={i} className={`text-[15px] leading-[1.8] mb-4 ${isQuote && i === 0 ? `${paraColor} font-normal` : paraColor}`}>
                {p}
              </p>
            ))}
            {children}
          </div>

          {/* Image Column */}
          <div className="w-full lg:w-5/12 text-center">
            <img
              src={image}
              alt={imageAlt}
              className="w-full max-w-[540px] h-auto mx-auto rounded-lg"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentSection;
